module.exports = {
  INIT: 'init',
  COMPLETED: 'completed',
};
